import { Link } from 'react-router-dom';
import {
  FaArrowRight,
  FaChartLine,
  FaCubes,
  FaGraduationCap,
  FaRobot,
  FaShoppingCart,
} from 'react-icons/fa';
import { HOME_INDUSTRIES } from '../../data/serviceLandingPages';
import '../../styles/home-industries.css';

const INDUSTRY_ICON_MAP = {
  'Ecommerce & marketplaces': FaShoppingCart,
  'Education & institutions': FaGraduationCap,
  'SaaS & product teams': FaCubes,
  'Operations & automation': FaChartLine,
};

export default function HomeIndustriesPreview() {
  return (
    <section className="home-industries-preview home-surface--light" aria-labelledby="home-industries-heading">
      <div className="home-industries-preview__shell">
        <div className="home-industries-preview__header">
          <div>
            <p className="home-focus-section__kicker">Industries we serve</p>
            <h2 id="home-industries-heading" className="h2 heading-title">
              Industry pathways shaped for real buyer journeys
            </h2>
            <p className="heading-text">
              We match delivery to your market with clear service paths, proof-led messaging, and technical
              stacks that support how your teams sell, publish, measure, and operate.
            </p>
          </div>
          <div className="home-industries-preview__signal" aria-hidden="true">
            <span>Market</span>
            <FaArrowRight />
            <span>Workflow</span>
            <FaArrowRight />
            <span>Growth</span>
          </div>
        </div>
        <div className="home-industries-preview__grid">
          {HOME_INDUSTRIES.map((industry, index) => {
            const Icon = INDUSTRY_ICON_MAP[industry.title] || FaRobot;
            return (
              <article key={industry.title} className="home-industries-preview__card">
                <div className="home-industries-preview__card-top">
                  <span className="home-industries-preview__icon">
                    <Icon aria-hidden="true" />
                  </span>
                  <span className="home-industries-preview__number">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3>{industry.title}</h3>
                <p>{industry.desc}</p>
                <div className="home-industries-preview__mini-flow" aria-hidden="true">
                  <span>UX</span>
                  <span>Build</span>
                  <span>Integrate</span>
                </div>
                <Link to={industry.to} className="home-focus-card__link">
                  Explore industry <FaArrowRight aria-hidden="true" />
                </Link>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
